import Dropdown from './Dropdown'
Vue.component('Dropdown', Dropdown)



// WEBPACK FOOTER //
// ./src/js/components/Dropdown/index.js